import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.AccountResetPassword1,
  LocationVarKey.AccountResetPassword2,
  LocationVarKey.AfterNavigateAccountLoginPassword,
  LocationVarKey.AfterNavigateAccountLoginPassword1,
  LocationVarKey.AfterNavigateAccountLoginPassword2
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Reset Password
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.AccountResetPassword1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.AccountResetPassword2}
        enableSwitchVar={LocationVarKey.AccountResetPassword2Enabled}
      />

      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1")}>
        <SwitchRow
          {...page}
          keyName={LocationVarKey.AfterNavigateAccountLoginPassword}
          label="Ask if they want to be navigated to your Account Login URL"
        />
        <Section
          {...page}
          hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginPassword, "1"), IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")])}
        >
          <SectionHeader
            {...page}
            subheading="After navigating the customer to a new page, the chat will open and respond based on the information below."
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginPassword, "1")}
          >
            {" "}
            After Navigate{" "}
          </SectionHeader>
          <TextAreaRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginPassword, "1")}
            marginTop
            label=" Message 1"
            keyName={LocationVarKey.AfterNavigateAccountLoginPassword1}
          />
          <TextAreaRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginPassword, "1")}
            marginTop
            label=" Message 2 (Optional)"
            keyName={LocationVarKey.AfterNavigateAccountLoginPassword2}
            enableSwitchVar={LocationVarKey.AfterNavigateAccountLoginPassword2Enabled}
          />
        </Section>
      </Section>
    </>
  );
}
